import { Link, Logout, UserMenu, useUserMenu } from 'react-admin';
import { MenuItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';

const SettingsMenuItem = () => {
  const { onClose } = useUserMenu() ?? {};
  return (
      <MenuItem component={Link} to="/settings" onClick={onClose}>
          <ListItemIcon>
              <SettingsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Settings</ListItemText>
      </MenuItem>
  );
};

export const AppUserMenu = () => (
    <UserMenu >
        {/* <SettingsMenuItem />
        <Divider /> */}
        <Logout />
    </UserMenu>
);
